import { pbjs } from '../prebid/index';
import amaLog from '../helpers/log';
import waitFor from '../helpers/waitfor';

let prebidRequestTracked = false;

export const prebidstats = (reset: boolean = false): any => {
  let bidRequestListener: Function | undefined;

  waitFor(() => typeof pbjs !== 'undefined' && pbjs && pbjs.onEvent).then(() => {
      amaLog('prebidstats attachListener');

      bidRequestListener = () => {
  
        if (prebidRequestTracked && reset === false) {
          return;
        }
        if (window.ama) {
          window.ama.adStats.add([
            {
              placement: 'prebid',
              gptEvent: 'slotRequested',
            },
          ]);
          window.ama.adStats.push();
          prebidRequestTracked = true;
          removeListener(); 
        }
      };
      const removeListener = () => { 
        amaLog('prebidstats pbjs.offEvent bidRequested - listener removed');        
        pbjs.offEvent?.('bidRequested', bidRequestListener);
      };
      pbjs.onEvent?.('bidRequested', bidRequestListener);
  }).catch((error) => {
    amaLog(`prebidstats Request ad-statistics failed to setup - ${error}`);
  });
};